module.exports = __webpack_public_path__ + "img/1.689597e8.svg";